import { render } from "./Units.vue?vue&type=template&id=5b2717b0&scoped=true"
import script from "./Units.vue?vue&type=script&lang=js"
export * from "./Units.vue?vue&type=script&lang=js"

import "./Units.vue?vue&type=style&index=0&id=5b2717b0&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2717b0"],['__file',"src/assets/js/pages/AddMeterConfig/Units.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b2717b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b2717b0', __exports__)) {
    api.reload('5b2717b0', __exports__)
  }
  
  module.hot.accept("./Units.vue?vue&type=template&id=5b2717b0&scoped=true", () => {
    api.rerender('5b2717b0', render)
  })

}


export default __exports__